module.exports = __webpack_public_path__ + "img/user_bg.73477254.png";